module.exports = __webpack_public_path__ + "img/join-bg (6).bb55cc53.jpg";